import { CREATE_PLAYLIST_URL_FRAGMENT, MY_PLAYLISTS_URL_FRAGMENT, PAGE_NAMES, PROFILE_URL_FRAGMENT, WATCH_LATER_URL_FRAGMENT, MY_TEAM_URL_FRAGMENT } from '../../constants/Navigation';
export const NAVBAR_ITEMS = [PAGE_NAMES.CATALOG, PAGE_NAMES.MY_LEARNING, PAGE_NAMES.WATCH_LATER, PAGE_NAMES.PLAYLISTS, PAGE_NAMES.CREATE_PLAYLIST, PAGE_NAMES.MY_TEAM, PAGE_NAMES.MY_PROFILE, PAGE_NAMES.PARTNER];
export const NAVBAR_ITEM_URLS = {
  [PAGE_NAMES.CATALOG]: '/',
  [PAGE_NAMES.MY_LEARNING]: '/my-learning',
  [PAGE_NAMES.WATCH_LATER]: WATCH_LATER_URL_FRAGMENT,
  [PAGE_NAMES.PLAYLISTS]: MY_PLAYLISTS_URL_FRAGMENT,
  [PAGE_NAMES.CREATE_PLAYLIST]: CREATE_PLAYLIST_URL_FRAGMENT,
  [PAGE_NAMES.MY_TEAM]: MY_TEAM_URL_FRAGMENT,
  [PAGE_NAMES.PARTNER]: '/partners',
  [PAGE_NAMES.MY_PROFILE]: PROFILE_URL_FRAGMENT
};